import { createFileRoute } from "@tanstack/react-router";
import { ClientOnly } from "@/components/ClientOnly";
import { PageLoader } from "@/components/PageLoader";
import AdminGuard from "@/components/admin/AdminGuard";
import Plus from "@/pages/Plus";

export const Route = createFileRoute("/plus")({
  component: () => (
    <AdminGuard><ClientOnly fallback={<PageLoader />}><Plus /></ClientOnly></AdminGuard>
  ),
});
